import { render, staticRenderFns } from "./toDoAssignedNotificationItem.vue?vue&type=template&id=61b5c6f7"
import script from "./toDoAssignedNotificationItem.vue?vue&type=script&lang=ts"
export * from "./toDoAssignedNotificationItem.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports